<template>
  <div>
    <b-table
      class="tab-b"
      ref="selectableTable"
      selectable
      :select-mode="selectMode"
      :items="phones"
      :fields="fields"
      @row-selected="onRowSelected"
      :tbody-tr-class="rowClass"
      responsive="sm"
    >
    </b-table>
    <b-row>
      <b-col cols="12">
        <b-form-input
          v-if="selectedOptions.isAdded"
          type="text"
          v-model="phoneValue"
          maxlength="9"
          @keyup="filterInput"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6" class="text-right">
        <b-button class="btn-white" @click="addContact">
          <font-awesome-icon icon="plus" />
          Agregar
        </b-button>
      </b-col>
      <b-col cols="6" class="text-left">
        <b-button
          :disabled="isRowSelected"
          class="btn-white"
          @click="createPhone"
        >
          <font-awesome-icon icon="plus" />
          Guardar
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  name: "MantenedorTelefono",
  data() {
    return {
      rowEdited: null,
      fields: [
        { key: "selected", label: "  " },
        { key: "contact", label: "Teléfono" },
        { key: "actions", label: "" },
      ],
      selectMode: "single",
      selected: [],
      phoneValue: "",
      dataPhones: [],
      selectedOptions: {
        isAdded: false,
      },
    };
  },
  props:{
    phones:{
      type:Array
    },
    selectedPhone:{
      type:Object
    },
    id:{
      type:Number
    }
  },
  computed: {
    ...mapState("module", ["token"]),
    isRowSelected() {
      if (this.phoneValue.length == 0) return true;
      else return false;
    },
 
    highestPriority() {
      if (this.phones.length == 0) return false;
      return this.phones.reduce((a, b) =>
        Number(a.priority) > Number(b.priority) ? a : b
      );
    },
  },

  methods: {
    filterInput() {
      this.phoneValue = this.phoneValue.replace(/[^0-9]/g, "");
    },
    onRowSelected(items) {
      this.$emit("update:selectedPhone",items[0])
      this.$bvModal.hide("modal-phone"); 
      this.$bvModal.hide("modal-phone-secondary"); 
    },
    addContact() {
       
      this.selectedOptions.isAdded = !this.selectedOptions.isAdded;
      const mayorPriority = this.highestPriority
        ? this.highestPriority.priority + 1
        : 0;
      let randomNumber = Math.floor(new Date().getTime() / 1000);
      this.dataPhones.push({
        created: true,
        active: true,
        clientId: this.id,
        contact: "",
        contactType: "PHONE",
        id: randomNumber,
        priority: mayorPriority,
      });
    },

    async createPhone() {
      this.dataPhones[0].contact = this.phoneValue;
      let dataSend = this.dataPhones[0];
      this.$store.commit("SET_LOADING", true);
      try {
        let response = await axios.post(
          process.env.VUE_APP_CLIENT_CORE_BASE +
            "/contacts",
          dataSend,
          {
            headers: {
              "Content-type": "application/json",
              "Authorization": "Bearer "+ this.token
            },
          }
        );
        let values = {
          variant: "success",
          msg: "Se ha creado exitosamente !",
        };
        this.$store.commit("SET_ERROR_MSG", values);
        this.$store.commit("setShowAlert", true);
        this.selectedOptions.isAdded = false;
        
        this.$emit('update',response.data)
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.commit("SET_LOADING", false);
        setTimeout(() => this.$store.commit("setShowAlert", false), 3000);
      }
    },
    rowClass(item, type) {
      if (!item || type !== "row"||!this.selectedPhone) return;
      if (item.id== this.selectedPhone.id)
        return "table-success";
    },
  },
};
</script>
<style>
.text-right {
  text-align: right;
}
.padding-five-bottom {
  margin-bottom: 3%;
}
.btn-padding {
  padding: 0.375rem 1.5rem 0.375rem 1.5rem !important;
}
::v-deep .b-table thead {
  background-color: transparent !important;
  color: black !important;
  font-weight: 500 !important;
  border: none !important;
}
::v-deep .b-table thead th {
  font-weight: 700 !important;
  border: none !important;
  font-size: 11pt;
}
.bg-red {
  background: #ff4c4c;
}
.color-white {
  color: white;
}
.width-10 {
  width: 21px;
  height: 23px;
}
.border-gray {
  border: 1px solid gray;
}

.bg-white {
  background: white;
  border-color: gray;
}
.border-color {
  border-color: rgb(254, 123, 1);
}
.color-orange {
  color: rgb(254, 123, 1) !important;
}
.bg-orange {
  background: rgb(254, 123, 1) !important;
}
.text-center {
  text-align: center;
}
</style>
